import { tailwindOverride } from '@getsynapse/design-system';
import intl from 'react-intl-universal';

export const renderTooltipArrow = () => {
  return (
    <div
      className={tailwindOverride(
        'whitespace-nowrap absolute z-5 top-full hidden group-hover:block -translate-x-1/2 h-0 w-0 border-dark-gray'
      )}
      style={{
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent',
        borderWidth: '8px',
        borderTop: 'none',
      }}
    />
  );
};

export const renderAlreadyAddedTooltip = (categoryIndex: number) => {
  return (
    <div
      className={tailwindOverride(
        'whitespace-nowrap absolute z-5 top-10 text-sm hidden group-hover:block bg-dark-gray text-white py-1 px-2 rounded',
        {
          '-left-18': categoryIndex % 4 === 3,
          '-left-9': categoryIndex % 4 !== 3,
        }
      )}
    >
      {intl.get('ADD_INSIGHT.ALREADY_ADDED')}
    </div>
  );
};
